<template>
  <div id="app">
    <div id='header' class='container red' ref='header'>
      <h3 class='item menu'>
        <router-link :to="{ name: 'Intro'}">About</router-link>
      </h3>
      <div class='item logo'>
        <a href='https://www.sfmoma.org/' target='_new'>
          <img src='@/images/moma-logo.png' height='50px' />
        </a>
      </div>
      <h3 class='item info'>
        <router-link :to="{name: 'Art', params: {journey: 'love', index: 3}}">
          Send Me Love</router-link>
      </h3>
    </div>

    <router-view v-bind='{headerHeight, footerHeight}'></router-view>
    <div id='footer'>
      <a v-for='footer in footerLinks' :href='footer.url' target='_new'>
        {{ footer.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      headerHeight: 60,
      footerHeight: 0,
      footerLinks: [
        {name: 'SFMOMA Lab', url: 'https://www.sfmoma.org/series/sfmoma-lab/'},
        {name: 'Send Me SFMOMA', url: 'https://www.sfmoma.org/read/send-me-sfmoma/'},
        {name: 'Privacy Policy', url: 'https://www.sfmoma.org/privacy-policy/'},
      ]
    }
  },
  mounted() {
    this.headerHeight = this.$refs.header.offsetHeight;
  },
  methods: {
  },
}
</script>

<style>
#header {
  top: 0;
  left: 0;
  width: calc(100% - 60px);
  padding: 25px 30px;
  /* box-shadow: 0 3px 15px rgba(68,73,76,0.2); */
  border-bottom: 1px solid rgba(68,73,76,0.2);
  background-color: #fff;
  z-index: 2000;
}

#header.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 50px;
  align-items: center;
}

#header a {
  color: inherit;
  text-decoration: none;
}

.menu {
  grid-column: 1 / 2;
}

.logo {
  grid-column: 2 / 3;
  text-align: center;
}

.info {
  grid-column: 3 / 4;
  text-align: right;
}

.card {
  /* box-shadow: 0 2px 8px 2px rgba(68,73,76,0.2); */
  border: 1px solid rgba(68,73,76,0.2);
  background-color: #fff;
  padding: 20px;
}

#footer {
  position: relative;
  background: #ff483b;
  padding: 12px 18px;
  font-size: 14px;
}

#footer a {
  color: #fff;
  text-decoration: none;
  padding: 0 12px;
  border-right: 1px solid;
}

#footer a:last-of-type {
  border-right: none;
}

/* for mobile portrait */
@media (min-width: 320px) and (max-width: 480px) {
  #header {
    width: calc(100% - 20px);
    padding: 25px 10px;
  }

  .card {
    padding: 10px;
  }

  #footer {
    padding: 12px 0px;
    margin: -2px;
  }

  /* #header.container {
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto;
    text-align: center;
  }

  .logo {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .menu {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    text-align: center;
    margin: 5px;
  }

  .info {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
    text-align: center;
    margin: 5px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/App.vue